import { MenuItemLateral } from "src/layouts/layout-privado/sidebar/Sidebar";
import { Roles } from "src/utils/roles/roles";

export const menuLateralGestion: MenuItemLateral[] = [
    {
        id: "opcion-aspirantes",
        label: "Aspirantes",
        expanded: true,
        icon: "group",
        path: "/gestion/aspirantes",
        rolesConAcceso: [Roles.ADMIN, Roles.GESTOR],
    },
];